import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { supabase } from '../lib/supabaseClient';

const {
  FiBarChart2,
  FiBookOpen,
  FiLogOut,
  FiMessageCircle
} = FiIcons;

function initialsFromName(name) {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  if (parts[0]) return parts[0].slice(0, 2).toUpperCase();
  return '?';
}

function initialsFromEmail(email) {
  const local = (email || '?').split('@')[0];
  return local.slice(0, 2).toUpperCase();
}

function AppHeader({ user, role = 'parent', studentChild = null }) {
  const navigate = useNavigate();
  const isStudent = role === 'student';

  const profile = isStudent
    ? {
      initials: initialsFromName(studentChild?.name || 'Student'),
      title: studentChild?.name || 'Student',
      detail: studentChild?.grade
        ? `${studentChild.grade} grade`
        : 'Student'
    }
    : {
      initials: initialsFromEmail(user?.email || 'Parent'),
      title: 'Parent',
      detail: user?.email || 'Household view'
    };

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/auth', { replace: true });
  };

  return (
    <header className="app-header">
      <NavLink
        aria-label={isStudent ? 'Go to Student Tutor' : 'Go to Parent Dashboard'}
        className="brand"
        to={isStudent ? '/' : '/parent'}
      >
        <span className="brand-mark">
          <SafeIcon icon={FiBookOpen} />
        </span>
        <span>Quantix</span>
      </NavLink>

      <nav
        aria-label="App navigation"
        className="role-switcher"
      >
        {isStudent ? (
          <NavLink
            className={({ isActive }) =>
              `role-link ${isActive ? 'active' : ''}`
            }
            end
            to="/"
          >
            <SafeIcon icon={FiMessageCircle} />
            <span>Student Tutor</span>
          </NavLink>
        ) : null}
        {!isStudent ? (
          <NavLink
            className={({ isActive }) =>
              `role-link ${isActive ? 'active' : ''}`
            }
            to="/parent"
          >
            <SafeIcon icon={FiBarChart2} />
            <span>Parent Dashboard</span>
          </NavLink>
        ) : null}
      </nav>

      <div className="flex items-center justify-self-end gap-3">
        <div className="profile-chip">
          <span className="profile-avatar">{profile.initials}</span>
          <span className="profile-copy">
            <strong>{profile.title}</strong>
            <small>{profile.detail}</small>
          </span>
        </div>
        <button
          className="flex items-center gap-1.5 rounded-lg px-2.5 py-2 text-[11px] font-semibold text-[#6c7773] transition hover:bg-[#f0f0ec] hover:text-[#24302d]"
          onClick={handleSignOut}
          type="button"
        >
          <SafeIcon icon={FiLogOut} />
          <span className="hidden sm:inline">Sign out</span>
        </button>
      </div>
    </header>
  );
}

export default AppHeader;
